onReady(($) => {
    const videoModules = $('.video-module')
    const videoModulesSingle = $('.article-hero-inner .video-module')

    if (videoModules.length === 0) {
        return
    }

    const loadVideo = () => {
        $(window)
            .off('scroll', loadVideo)

        videoModules.each((i, videoModule) => {
            $('.cta-button', videoModule)
                .on('click', (e) => {
                    e.preventDefault()
                    $('img', videoModule)
                        .trigger('click')
                })

            // Load the wistia video
            $('.wistia_embed', videoModule)
                .each((i, wistiaEmbed) => loadWistiaMedia(wistiaEmbed.dataset.videoId))
        })

        loadWistiaLibrary()
    }
    if (videoModulesSingle.length > 0) {
        loadVideo()
        $('.video-button')
            .on('click', (e) => {
                e.preventDefault()
                $('img', videoModulesSingle)
                    .trigger('click')
            })

        return
    }
    $(window)
        .on('scroll', loadVideo)

    // Load if user has already scrolled
    if (window.scrollY > 0) {
        loadVideo()
    }
})
